import { GetTakePhotoGuideVideoQueryParamsType } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getTakePhotoGuideVideo/getTakePhotoGuideVideoQuery.type';
import { getTakePhotoGuideVideoFunction } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getTakePhotoGuideVideo/getTakePhotoGuideVideoQueryFunction';
import { queryOptions } from '@tanstack/react-query';

export const getTakePhotoGuideVideoQueryOptions = (
  params: GetTakePhotoGuideVideoQueryParamsType,
) => {
  return queryOptions({
    queryKey: ['takePhotoGuideVideo', params],
    queryFn: () => getTakePhotoGuideVideoFunction(params),
    enabled: params.enabled,
  });
};
